<template>
    <div>
        <audio
            :src="src"
            ref="audio"
            @ended="handleEndedEvent"
            @play="handlePlayEvent"
            @timeupdate="handleTimeUpdateEvent">
        </audio>

        <slot v-bind:data="{handleButtonClick, isPlaying}">
            <button class="color-button"
                :disabled="isPlaying"
                :class="[{'is-playing': isPlaying}, color]" 
                @click="handleButtonClick">
                {{ title }}
            </button>
        </slot>

        <div class="progress"
            :class="{'is-playing': isPlaying}">
            <div class="progress__bar"
                :style="{'transform': `scaleX(${this.progressDecimel})`}"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    @import '../scss/design.scss';

    .progress {
        width: 80px;
        height: 8px;
        overflow: hidden;
        border-radius: 4px;
        margin: 10px auto;
        position: relative;
        background-color: #c1a275;
        opacity: 0;
        transform: translateY(12px);
        transition: all .35s ease;
        box-shadow: 0 0 0 3px rgba(black, .3);

        &.is-playing {
            opacity: 1;
            transform: none;
        }

        &__bar {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            transform-origin: left center;
            background-color: #40230D;
        }
    }
</style>

<script>
export default {
    props: {
        src: {
            type: String,
        },
        title: {
            type: String
        },
        allowSkip: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            progressDecimel: 0,
            isPlaying: false
        }
    },
    watch: {
        src() {
            this.stop();
        }
    },
    computed: {
        /** @returns {HTMLMediaElement} */
        $audio() {
            return this.$refs.audio;
        },
    },
    methods: {
        handleTimeUpdateEvent(e) {
            this.progressDecimel = this.$audio.currentTime / this.$audio.duration;
            this.$emit('timeupdate')
        },
        handlePlayEvent() {
            this.isPlaying = true;
            this.$emit('play')
        },
        handleEndedEvent() {
            this.stop();
            this.doEnd();
        },
        doEnd() {
            this.$emit('ended')
        },
        play() {
            this.$audio.play();
        },
        stop() {
            this.$audio.pause();
            this.$audio.currentTime = 0;
            this.isPlaying = false;
            this.progressDecimel = 0;
        },
        skip() {
            this.stop();
            this.$emit('skipped');
        },
        handleButtonClick() {
            if(this.isPlaying) {
                if(this.allowSkip) {
                    this.skip();
                }
                return;
            } else {
                this.play();
            }
        }

    }
}
</script>